import React, { Fragment, useRef, useEffect } from 'react'
import { ArrowLeft, Cross } from '@components/icons'
import { useUI } from '@components/ui'
import {
  DEFAULT_LOGIN_VALUES,
  INewLoginFormProps,
  LOGIN_FORM_ID,
  LOGIN_FORM_SCHEMA,
  generateLoginModalFooter,
} from './loginHelper'
import SubmitButton from '@components/common/SubmitButton'
import { LoginPageAction } from '@components/utils/constants'
import { INVALID_OTP } from '@components/utils/textVariables'
import { FormikProps } from 'formik'
import NewLoginForm from './NewLoginForm'
import { Transition, Dialog } from '@headlessui/react'
import ErrorView from '@components/ui/ErrorView'
import {
  getErrorMessage,
  resetErrorSubmitData,
} from '@framework/utils/app-util'
import Router from 'next/router'

interface ILoginModalDialogBox {
  isChannelStore: boolean
  isOTPSent: boolean
  setIsOTPSent: (val: boolean) => void
  setTimer: (val: number) => void
  mobileNumber: string
  timer: number
  resendOTP: (val: any) => void
  LOGIN_FORM_FIELDS: any
  handleLogin: (val: any) => void
  submitState: any
  isError: boolean
  show: boolean
  submitDispatch: any
}

const LoginModalDialogBox = (props: ILoginModalDialogBox) => {
  const {
    isChannelStore,
    isOTPSent,
    setIsOTPSent,
    setTimer,
    mobileNumber,
    timer,
    resendOTP,
    LOGIN_FORM_FIELDS,
    handleLogin,
    submitState,
    isError,
    show,
    submitDispatch,
  } = props

  const { loginCustomTitle, user, setSidebarView } = useUI()

  const newLoginFormRef: any = useRef<FormikProps<INewLoginFormProps>>(null)

  const handleLoginShow = () => {
    const tempNewUrl = window?.location?.href?.replaceAll('#loginOpen', '')
    const newUrl = tempNewUrl?.replaceAll('#loginOpen', '')
    const isLoginOpen = Router?.asPath?.includes('#loginOpen')
    Router?.replace(newUrl)
    if (show && isLoginOpen) {
      Router.back()
    }
    setSidebarView('')
  }

  return (
    <>
      <Transition.Root show={show} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-99"
          onClose={() => {
            handleLoginShow()
            setIsOTPSent(false)
            setTimer(0)
            // close()
          }}
        >
          <div className={`fixed inset-0 left-0 bg-black/[.5]`} />
          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div
                className={`fixed ${
                  isChannelStore ? 'top-auto bottom-0' : 'inset-y-0'
                } right-0 flex max-w-full pointer-events-none`}
              >
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-400"
                  enterFrom={`${
                    isChannelStore ? 'translate-y-full' : 'translate-x-full'
                  }`}
                  enterTo={`${
                    isChannelStore ? 'translate-y-0' : 'translate-x-0'
                  }`}
                  leave="transform transition ease-in-out duration-500 sm:duration-400"
                  leaveFrom={`${
                    isChannelStore ? 'translate-y-0' : 'translate-x-0'
                  }`}
                  leaveTo={`${
                    isChannelStore ? 'translate-y-full' : 'translate-x-full'
                  }`}
                >
                  <Dialog.Panel className="w-screen max-w-md pointer-events-auto">
                    <div
                      className={`relative z-50 flex flex-col ${
                        isChannelStore ? 'h-auto pick-pay-go-wrapper' : 'h-full'
                      } bg-white shadow-xl`}
                    >
                      <div className="z-10 px-0 py-0 pb-0 sm:px-0 left-1 top-1">
                        <div className="flex justify-between px-6 py-6 pb-4 mb-0 border-b sm:px-6">
                          {!isOTPSent && (
                            <>
                              {(loginCustomTitle && loginCustomTitle !== '') ||
                              isChannelStore ? (
                                <h3
                                  className="text-xl font-bold text-black truncate dark:text-black"
                                  style={{ maxWidth: '80vw' }}
                                >
                                  {isChannelStore
                                    ? 'Verify your Mobile No.'
                                    : loginCustomTitle}
                                </h3>
                              ) : (
                                <h3 className="text-xl font-bold text-black dark:text-black">
                                  Verify your Mobile No.
                                </h3>
                              )}
                            </>
                          )}
                          {isOTPSent && (
                            <div className="flex justify-start items-center gap-3">
                              <button
                                type="button"
                                className="text-black rounded-md outline-none hover:text-gray-500"
                                onClick={() => {
                                  setIsOTPSent(false)
                                  setTimer(0)
                                }}
                              >
                                <ArrowLeft
                                  className="relative top-0 w-6 h-6"
                                  aria-hidden="true"
                                />
                              </button>
                              <h3 className="text-xl font-bold text-black dark:text-black">
                                Enter OTP
                              </h3>
                            </div>
                          )}
                          <button
                            type="button"
                            className="text-black rounded-md outline-none hover:text-gray-500"
                            onClick={() => {
                              handleLoginShow()
                              setIsOTPSent(false)
                              setTimer(0)
                              // close()
                            }}
                            onMouseDown={() => {
                              handleLoginShow()
                              setIsOTPSent(false)
                              setTimer(0)
                              // close()
                            }}
                          >
                            <span className="sr-only">Close panel</span>
                            <Cross
                              className="relative top-0 w-7 h-7"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </div>
                      <div
                        className={`p-6 ${
                          isChannelStore ? 'py-4 pb-6' : 'py-2'
                        } overflow-y-auto`}
                      >
                        {/* New Login Form start */}
                        <div className="flex justify-between">
                          {isOTPSent && (
                            <div className="flex items-center justify-between w-full">
                              <h3 className="my-2 text-sm text-black">
                                OTP sent on {mobileNumber}
                              </h3>
                              {timer ? (
                                <p className="text-xs text-black opacity-50">
                                  Resend in <span className="w-4">{timer}</span>
                                  s
                                </p>
                              ) : (
                                <button
                                  type="button"
                                  className="text-xs font-semibold text-orange"
                                  onClick={() => {
                                    resendOTP(newLoginFormRef?.current?.values)
                                  }}
                                >
                                  Resend OTP
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                        <NewLoginForm
                          isOTPSent={isOTPSent}
                          formId={LOGIN_FORM_ID}
                          formFields={LOGIN_FORM_FIELDS}
                          schema={LOGIN_FORM_SCHEMA}
                          defaultValues={DEFAULT_LOGIN_VALUES}
                          onSubmit={handleLogin}
                          mobileNumber={mobileNumber}
                          ref={newLoginFormRef}
                        />

                        {!isOTPSent && (
                          <div className="px-0 py-4 pt-0 mt-2 chk-btn sm:px-0 custom-next-btn">
                            <SubmitButton
                              formId={LOGIN_FORM_ID}
                              cssClass="w-full flex items-center justify-center btn-basic-property -mr-0.5 text-white bg-black border-2 border-black rounded-sm hover:bg-gray-800 hover:text-white sm:px-6 hover:border-gray-900"
                              submitState={submitState}
                              source={LoginPageAction.SEND_OTP}
                            >
                              <>Request OTP</>
                            </SubmitButton>
                          </div>
                        )}

                        {isOTPSent && (
                          <div className="px-0 py-4 pt-0 mt-2 chk-btn sm:px-0 custom-next-btn">
                            {isError ? (
                              <div className="mb-3 mt-3 m-[-24px] w-auto">
                                <div
                                  className={`bg-ribbon-red justify-center w-full px-10 py-4 text-center align-center sticky top-24 z-50`}
                                >
                                  <h4 className="text-16 font-medium text-[#fff] capitalize">
                                    {INVALID_OTP}
                                  </h4>
                                </div>
                              </div>
                            ) : null}
                            <SubmitButton
                              formId={LOGIN_FORM_ID}
                              cssClass="w-full flex items-center btn-basic-property justify-center px-4 -mr-0.5 text-white bg-black border-2 border-black rounded-sm hover:bg-gray-800 hover:text-whitesm:px-6 hover:border-gray-900"
                              submitState={submitState}
                              source={LoginPageAction.LOGIN}
                            >
                              <>
                                <span className="hidden sm:inline-block">
                                  Verify OTP
                                </span>
                                <span className="inline-block sm:hidden">
                                  Verify & Login
                                </span>
                              </>
                            </SubmitButton>
                          </div>
                        )}
                        {generateLoginModalFooter(user)}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {submitState?.error && (
        <ErrorView
          error={{
            ...submitState?.error,
            ...{
              error_message: getErrorMessage(submitState?.error),
            },
          }}
          closeModal={() => resetErrorSubmitData(submitDispatch)}
        />
      )}
    </>
  )
}

export default LoginModalDialogBox
